import { Video } from '@/types/Video';
import Request from './request';
import { SearchResult } from '@/types/RequestTypes';

export default class Brightcove {
  private policy = 'BCpkADawqM3ZsuM7c3C_6HxSq_mEpom88BzBWM_C51BH-b_B5bFmYI-cQ_Kpn4Ci_mKdNAD3PTpXo0niUFL_22YhV7whvN41m-7Jx5bKkUSit5Mb1HQleKiqGOTIUUenR5R0COSwZaA42zZB'
  private accountId = '1555966122001'
  private brightcoveUrl = `https://edge.api.brightcove.com/playback/v1/accounts/${this.accountId}`
  private request = new Request({ 'Accept': `application/json;pk=${this.policy}` })

  async getVideo(videoId: string, adConfigId?: string, liveToken?: string): Promise<Video> {
    let url = `${this.brightcoveUrl}/videos/${videoId}`;

    if (adConfigId) {
      url = `${url}?ad_config_id=${adConfigId}`;
    }

    //Live token replaced ad config id param
    if (liveToken) {
      url = `${url}?livePlaybackToken=${liveToken}`;
    }

    return await this.request.get<Video>(url);
  }

  async getVideoByReference(materialid: string, adConfigId?: string): Promise<Video> {
    let url = `${this.brightcoveUrl}/videos/ref:${materialid}`;

    if (adConfigId) {
      url = `${url}?ad_config_id=${adConfigId}`;
    }

    return await this.request.get<Video>(url);
  }

}